module.exports = __webpack_public_path__ + "images/7217522cc928fcc0f07ddfc4a997f9a4.svg";